"use client"
import { Box } from "@mui/material"
import NotificationDropdown from "../asset-components/NotificationDropdownScreen"
import { COLORS } from "@/utils/constants/theme/colors"
import SergoLogo from "../asset-components/SergoLogo"
import AvatarMenu from "../asset-components/AvatarMenu"
import { useRouter } from "next/navigation"
import { Account } from "@/views/tabs/TabAccount"
import { useEffect, useState } from "react"
import { useReadLocalStorage } from "usehooks-ts"
import { ROUTES, API_END_POINT } from "@/apiClient/apiEndpoints"
import { apiClient } from "@/apiClient/apiService"
import { useQuery } from "react-query"

export type HEADER_PROPS = {
  headerText?: string | undefined
  hotelName?: string
  reservationNumber?: string
  withPropertyInfo?: boolean
  withPersonalInfo?: boolean
}
export interface UserAccount {
  message: string
  data: Account
}
export interface Organization {
  id: number
  name: string
}

export default function AdminAppHeader() {
  const router = useRouter()
  const [isQueryEnabled, setQueryEnabled] = useState(true)
  const { data } = useQuery<{ data: UserAccount }>({
    queryKey: ["adminUserData"],
    queryFn: async () => {
      return await apiClient.get(`${API_END_POINT.GET[ROUTES.getUserDetails]}`)
    },
    enabled: isQueryEnabled,
  })
  return (
    <>
      <Box
        sx={{
          display: "flex",
          backgroundColor: COLORS.adminAppBgColor,
          padding: "1rem",
          px: "4rem",
          height: "auto",
          alignItems: "center",
          justifyContent: "space-between",
          minHeight: "100px",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", width: "18%" }}>
          <Box onClick={() => router.push("/")} sx={{ cursor: "pointer" }}>
            <SergoLogo width="8rem" height="4rem" />
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            mr: "1rem",
            "& :hover": {
              cursor: "pointer",
            },
          }}
        >
          <NotificationDropdown />
          <AvatarMenu userData={data?.data?.data} />
        </Box>
      </Box>
    </>
  )
}
